import type { GetStaticPropsContext } from 'next';
import MarketingSite from '~/components/marketing/MarketingSite';
import { withTranslationProps } from '~/lib/props/with-translation-props';

export default function Page() {
  return <MarketingSite page="contact" />;
}

export async function getStaticProps({ locale }: GetStaticPropsContext) {
  const { props } = await withTranslationProps({ locale });
  return { props };
}
